import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var BusinessLaw = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9 4.49H30.1v-.998C30.1 1.497 28.5 0 26.5 0h-9c-2 0-3.6 1.596-3.6 3.492v.998H2.1C1 4.49 0 5.488 0 6.585v26.44c0 1.197 1 2.095 2.1 2.095h12.1c.5 0 1-.399 1-.997a1 1 0 0 0-1-.998H2.1c-.1.1-.1 0-.1 0V6.485h39.9c.1 0 .1 0 .1.1v26.44c0 .1-.1.1-.1.1H29.8c-.5 0-1 .399-1 .998a1 1 0 0 0 1 .997h12.1c1.2 0 2.1-.898 2.1-2.095V6.585c0-1.097-1-2.095-2.1-2.095Zm-26 0v-.998c0-.898.7-1.596 1.6-1.596h9c.9 0 1.6.698 1.6 1.596v.998H15.9Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1 23.646 34 13.77c-.1-.4-.5-.599-.9-.599H27a5.042 5.042 0 0 0-4.9-3.891c-2.4 0-4.5 1.696-4.9 3.891H11c-.4 0-.8.2-.9.599L6 23.646c-.1.1-.1.3-.1.5 0 2.793 2.3 4.988 5.1 4.988s5-2.195 5.1-4.89c0-.199 0-.298-.1-.498l-3.6-8.58H21v26.838h-5.8c-.5 0-1 .4-1 .998a1 1 0 0 0 1 .998h14.2c.5 0 1-.4 1-.998a1 1 0 0 0-1-.998H23V15.166h8.6l-3.6 8.48c-.1.2-.1.3-.1.5 0 2.793 2.3 4.988 5.1 4.988s5.1-2.195 5.1-4.89c.1-.199.1-.398 0-.598ZM11 27.138c-1.4 0-2.6-.898-3-2.195h6a3.12 3.12 0 0 1-3 2.195Zm2.7-3.99H8.3l2.7-6.386 2.7 6.385Zm5.4-9.978c.4-1.197 1.5-1.995 2.9-1.995s2.5.798 2.9 1.995h-5.8ZM33 16.662l2.7 6.386h-5.4l2.7-6.386Zm0 10.476c-1.4 0-2.6-.898-3-2.195h6a3.12 3.12 0 0 1-3 2.195Z"
  }));
});
BusinessLaw.displayName = 'BusinessLaw';
BusinessLaw.defaultProps = {
  'aria-label': 'BusinessLaw'
};
export default BusinessLaw;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/BusinessLaw.js
// module id = 2985
// module chunks = 11